import { gsap } from "gsap";

const navigationFixed = () => {
	const header = document.querySelector(".jbg-primary-nav__header");
	const navHeight = header.offsetHeight;

	let lastScroll = window.scrollY;
	let scrollUpStart = null;

	window.addEventListener("scroll", () => {
		if (document.body.classList.contains("jbg-primary-nav__offcanvas-show"))
			return;

		const currentScroll = window.scrollY;

		// top of page
		if (currentScroll === 0) {
			header.classList.remove("jbg-primary-nav__header-fixed");
			scrollUpStart = null;
		} else if (currentScroll < lastScroll) {
			// scrolling up
			if (scrollUpStart === null) {
				scrollUpStart = lastScroll;
				header.classList.add("jbg-primary-nav__header-fixed");
			}

			const upDelta = scrollUpStart - currentScroll;
			const progress = Math.min(upDelta / navHeight, 1);
			gsap.set(header, {
				top: gsap.utils.interpolate(-navHeight, 0, progress),
			});
		} else {
			// scrolling down
			header.classList.remove("jbg-primary-nav__header-fixed");
			gsap.set(header, { top: -navHeight });
			scrollUpStart = null;
		}

		lastScroll = currentScroll;
	});
};

export default navigationFixed;
